/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Container as MContainer, Divider } from '@mui/material';
import { deviceSizes } from '@app/config/devices';

// export const BoxContianer = styled(MContainer)`
//   padding-top: 80px;
//   padding-bottom: 9.375rem;
//   min-height: 80vh;
//   width: 100%;
// `;

export const LandingContainer = styled.div`
  //background-color: ${({ theme }) => theme.primary.main};
  /* height: 100vh; */
  background: ${({ theme }) => theme.gradient.background};
  min-height: 40.875rem;
  padding-top: 80px;

  @media (max-width: ${deviceSizes.tablet}) {
    min-height: 42.875rem;
  }
  @media (max-width: ${deviceSizes.sm}) {
    min-height: 37.875rem;
  }
  /* 
background: #f35252;
background: -webkit-linear-gradient(to bottom, #880E4F, #f35252);  
background: linear-gradient(to bottom, #f35252, #880E4F); 
 */
`;

// CB356B

// f35252

export const StyledDivider = styled(Divider)`
  && {
    height: 1.5px;
    background: linear-gradient(270deg, #231B42 -0.56%, #B959A9 4.68%, #6854E0 30.87%, #2BB1DB 63.34%, #4F4087 79.57%, #AEAF63 95.81%, #231B42 100%);
  }
`;
